<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <div>
        <h4 class="fw-bold mb-0"><i class="fas fa-pause-circle me-2 text-warning"></i>Backtest</h4>
        <p class="text-muted small mb-0 mt-1">
          Pause a running replay while the live session is trading, so it does not compete with
          live for market data. Resume to continue from the frozen instant.
        </p>
      </div>
    </div>
    <BacktestPausePanel @status-changed="onStatusChanged" />
  </div>
</template>

<script>
import BacktestPausePanel from '../components/BacktestPausePanel.vue';

export default {
  name: 'BacktestView',
  components: { BacktestPausePanel },
  methods: {
    onStatusChanged(paused) {
      console.log(`[BacktestView] Backtest pause requested: ${paused}`);
    },
  },
};
</script>
